import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { GLOBAL_ERROR_EVENT } from "../hooks/globalError";
import './GlobalErrorModalHost.scss';

Modal.setAppElement("#root");

export default function GlobalErrorModalHost() {
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState(null);
  const lastShownAtRef = useRef(0);

  useEffect(() => {
    const handler = (e) => {
      const now = Date.now();
      if (now - lastShownAtRef.current < 1500) return;
      lastShownAtRef.current = now;

      setPayload(e.detail);
      setOpen(true);
    };

    window.addEventListener(GLOBAL_ERROR_EVENT, handler);
    return () => window.removeEventListener(GLOBAL_ERROR_EVENT, handler);
  }, []);

  const close = () => setOpen(false);

  return (
    <Modal
      isOpen={open}
      onRequestClose={close}
      contentLabel="Server Error"
      className="globalErrorModal"
      overlayClassName="globalErrorModalOverlay"
    >
      <h2>{payload?.title ?? "오류"}</h2>
      <p>{payload?.message ?? "문제가 발생했습니다."}</p>

      {!!payload?.status && (
        <div className="statusInfo">status: {payload.status}</div>
      )}

      {!!payload?.detail && (
        <details>
          <summary>상세 정보</summary>
          <pre>
            {typeof payload.detail === "string"
              ? payload.detail
              : JSON.stringify(payload.detail, null, 2)}
          </pre>
        </details>
      )}

      <div className="buttonArea">
        <button className="reloadBtn" onClick={() => window.location.reload()}>
          새로고침
        </button>
        <button className="closeBtn" onClick={close}>닫기</button>
      </div>
    </Modal>
  );
}
